export default "__VITE_ASSET__8d90e081__"